export const TOOLTIP_OFFSET_PX = 12;
export const ARROW_PADDING_PX = 12;
export const WINDOW_MARGIN_PX = 15;

export const HOVER_DELAY_MS = 400;
export const TOUCH_DELAY_MS = 700;
export const TRANSITION_DURATION_MS = 200;
